export const schoolExtensions = {
  /**
   * Combines all of the address "parts" into a single string for display.
   * State and postal code are joined with a space (US convention: "Chicago, IL 60601").
   * For international schools, country is appended;
   *
   * @returns {string} The "full" address for the model.
   */
  getFullAddress() {
    const country = this.getCountry();
    const isInternational = country && country !== 'United States of America';

    const stateAndPostalCode = [this.getState(), this.getPostalCode()].filter(Boolean).join(' ');

    return [
      this.getAddressLine1(),
      this.getAddressLine2(),
      this.getCity(),
      stateAndPostalCode,
      isInternational ? country : null
    ]
      .filter(Boolean)
      .join(', ');
  }
};
